import { DailyReportFormScreen } from "app/screens/residents/show/DailyReportFormScreen";
import { useLocalSearchParams } from "expo-router";

export default function ReportFormPage() {
  const { formId } = useLocalSearchParams();
  const form = Number(formId);
  return <DailyReportFormScreen formId={form} />;
}
